import * as React from 'react';

import {convertLineToBar} from '../../util/plotHelpers/lines';
import {type Line} from '../../util/plotHelpers/types';
import {BarChart as VisBarChart} from '../vis/BarChart/BarChart';
import {type RunsLinePlotConfig} from './types';
import {isValidLine} from './utils/checkTypes';

export const BarChart = React.memo(
  (props: {lines: Line[]; config: RunsLinePlotConfig}) => {
    const {lines, config} = props;
    const filteredLines = lines.filter(isValidLine);
    const bars = filteredLines.map(convertLineToBar);

    return (
      <VisBarChart
        bars={bars}
        min={config.yAxisMin ?? undefined}
        max={config.yAxisMax ?? undefined}
        showAllLabels
      />
    );
  }
);

BarChart.displayName = 'BarChart';
